module.exports = __webpack_public_path__ + "img/logo.2ce6f26d.png";